import { render } from "./DataGrid.vue?vue&type=template&id=bdef4c5a&scoped=true"
import script from "./DataGrid.vue?vue&type=script&lang=js"
export * from "./DataGrid.vue?vue&type=script&lang=js"

import "./DataGrid.vue?vue&type=style&index=0&id=bdef4c5a&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdef4c5a"]])

export default __exports__